<div class="emperor-ui-hint-with-icon-wrapper">
  <emperor-icon
    *ngIf="hintWithIcon?.icon"
    [name]="hintWithIcon.icon"
    [style.color]="hintWithIcon.color"
  ></emperor-icon>
  <div class="hint">
    {{ hintWithIcon?.value }}
  </div>
</div>
